import { mediaUrl } from 'helpers/mediaUrl';
import './PartnerCard.css';

/**
 * Картка спонсора або партнера заходу.
 * Раніше компонент падав, якщо в партнера не було логотипа: деструктуризація
 * partner.logo.data.attributes.url не переживала null.
 */
export default function PartnerCard({ partner }) {
  const { name, link } = partner;
  const url = mediaUrl(partner?.logo?.url);

  const content = (
    <>
      {url ? (
        <img className='partner-img' src={url} alt='' loading='lazy' />
      ) : (
        <span className='partner-img partner-img--empty' aria-hidden='true' />
      )}
      <span className='partner-name'>{name}</span>
    </>
  );

  if (!link) {
    return <div className='partner-card'>{content}</div>;
  }

  return (
    <a href={link} target='_blank' rel='noreferrer' className='partner-card partner-card--linked'>
      {content}
    </a>
  );
}
